import * as React from "react";
import { AdminProductUpdatesContext } from "./AdminProductUpdatesProvider";

export const useAdminProductUpdates = () => React.useContext(AdminProductUpdatesContext);
